import subMinutes from "date-fns/subMinutes";

const dateToUTC = (date: Date) => subMinutes(date, date.getTimezoneOffset());

export default dateToUTC;
